import create from "./create";
import del from "./del";

export default {
  namespaced: true,
  modules: {
    del,
    create,
  },
};
